import serverAPI from './serverAPI';
import { authState } from '@/services/integrations/auth0';

enum SiemLoggingLevel {
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  CRITICAL = 'CRITICAL',
}

type SiemLoggingRequest = {
  event_name: string;
  message: string;
  user?: string;
  level?: SiemLoggingLevel;
};

const makeRequest = async (data: SiemLoggingRequest) => {
  await serverAPI.post('/siem-logging', {
    ...data,
    user: authState.userIds.employeeId,
  });
};

const warn = async (data: SiemLoggingRequest) => {
  await makeRequest({ ...data, level: SiemLoggingLevel.WARN });
};

const error = async (data: SiemLoggingRequest) => {
  await makeRequest({ ...data, level: SiemLoggingLevel.ERROR });
};

const critical = async (data: SiemLoggingRequest) => {
  await makeRequest({ ...data, level: SiemLoggingLevel.CRITICAL });
};

export default {
  warn,
  error,
  critical,
};
